import React, {useState} from "react"
import {Button, Form, message, Modal, Upload} from "antd"
import {PlusOutlined} from "@ant-design/icons"
import TextArea from "antd/es/input/TextArea"
import {validateImageFile} from "../../../util"
import {
    checkClubUpload,
    clubComplaintAddProof,
    clubComplaintHandle,
    uploadImageToQiNiu
} from "../../../api/complaintManager"

const ClubComplaintHandle = ({record, disabled}) => {

    const [showHandle, setShowHandle] = useState(false)
    const [content, setContent] = useState('')
    const [fileList, setFileList] = useState([])
    const [previewOpen, setPreviewOpen] = useState(false)
    const [previewImage, setPreviewImage] = useState('')
    const [previewTitle, setPreviewTitle] = useState('')
    const [isLoading, setIsLoading] = useState(false)

    const showHandleForm = () => {
        setShowHandle(true)
    }

    const getBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj)
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true)
        setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1))
    }

    const handleChange = ({fileList: newFileList}) => {
        let list = newFileList.map(file => {
            file.status =  'done'
            return file
        })
        setFileList(list)
    }

    /**
     * 批量图片上传（上传至七牛云CDN）
     */
    const handleUpload = async (token, urls) => {
        // 创建一个包含所有上传Promise的数组
        const uploadPromises = urls.map((url, index) => {
            return uploadImageToQiNiu(token, url).then(res => {
                console.log('handleUpload', res)
                // 返回结果时，包含原始索引，以便之后排序
                return {index, result: `https://images.sport147.cn/${res.data.key}`}
            })
        })

        // 等待所有上传操作完成
        const results = await Promise.all(uploadPromises)

        // 根据原始索引对结果进行排序
        results.sort((a, b) => a.index - b.index)

        // 提取排序后的结果
        return results.map(item => item.result)
    }

    const handleComplaint = async () => {
        try {
            setIsLoading(true)
            if (content.length === 0 || content.trim().length === 0) {
                message.error("请输入处理描述")
                return
            }

            let photos = ''
            if (fileList.length > 0) {
                let urls = fileList.map(file => file.originFileObj)

                const checkRes = await checkClubUpload(urls, sessionStorage.getItem('club_id'))
                if (checkRes.status !== 1) {
                    message.error("图片上传次数已达上限，请明日再试")
                    return
                }

                const uploadRes = await handleUpload(checkRes.data, urls)
                photos = uploadRes.toString()
            }

            let nickName = sessionStorage.getItem('user_nickname')

            let formData = {
                complaintId: record.id,
                operatorName: nickName ? nickName : "-",
                content: content ? content : null,
                photos: photos ? photos : null
            }
            let formResStatus
            if (record.status === 5) {
                const res = await clubComplaintAddProof(formData)
                formResStatus = res.status
            }else {
                const res = await clubComplaintHandle(formData)
                formResStatus = res.status
            }

            if (formResStatus === 1) {
                message.success("处理成功")
                await window.location.reload()
            } else {
                message.error(formRes.detail)
            }

        } catch (e) {
            message.error("处理投诉失败")
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div>
            <Button type={"primary"} disabled={disabled} onClick={() => showHandleForm()}>处理</Button>
            <Modal open={showHandle} width={800} closable={true} onCancel={() => setShowHandle(false)} footer={(
                <Button type={"primary"} onClick={() => handleComplaint()} loading={isLoading}>提交</Button>
            )}>
                <div style={{padding: '0px 20px', height: '500px'}}>
                    <div style={{fontSize: '20px', marginBottom: '30px', fontWeight: 'bold'}}>{record.status !== 5 ? "处理投诉" : "补充凭证"}</div>
                    <Form>
                        <Form.Item label="处理描述">
                            <TextArea value={content} showCount maxLength={500} placeholder={"描述处理该投诉单的详情"} onChange={(e) => setContent(e.target.value)} />
                        </Form.Item>
                        <Form.Item label="图片证明">
                            <Upload action={''} style={{marginLeft: '30px'}} listType="picture-card" multiple maxCount={9} fileList={fileList} beforeUpload={(file) => (validateImageFile(file) ? true : Upload.LIST_IGNORE)} onChange={handleChange} onPreview={handlePreview}>
                                {fileList.length >= 9 ? null : <PlusOutlined/>}
                            </Upload>
                        </Form.Item>
                    </Form>

                    <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={() => setPreviewOpen(false)}>
                        <img alt="预览图片" style={{width: '100%'}} src={previewImage} />
                    </Modal>
                </div>
            </Modal>
        </div>
    )
}

export default ClubComplaintHandle


// WEBPACK FOOTER //
// ./src/containers/ClubComplaintManager/component/ClubComplaintHandle.js